export const selectIsPremiumSafe = (state) =>
  'details' in state ? state.details.isPremium : state.eventDetails.isPremium;
